import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface Props {
  children: ReactNode;
}

/**
 * Wrapper que renderiza o filho APENAS se o usuário está autenticado.
 * Caso contrário, redireciona para /login.
 */
export function ProtectedRoute({ children }: Props) {
  const isAuthenticated = useAuthStore((state) => state.token !== null);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
